import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KTSVG } from "../../../_metronic/helpers";
import { InvoiceTemplateInitialsForAdd, InvoiceTemplateInitialsForUpdate } from "./interfaces/invoicetemplateClass";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
    addInvoiceTemplateAsync, updateInvoiceTemplateAsync
} from "./invoiceTemplateSlice";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from "react-i18next";
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import CanvasLoader from "../../../common/CanvasLoader";

export const InvoiceTemplateForm = (props: any) => {
    const { t } = useTranslation();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(InvoiceTemplateInitialsForAdd)
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    const [selectedOptionExternalUser, setselectedOptionExternalUser] = useState<{ value: string; label: string } | null>(null);
    const [AccountInvoiceTemplateId, setAccountInvoiceTemplateId] = useState<number | null>(null);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.invoiceTemplate);
    const dispatch = useAppDispatch();
    const { maxMenuHeight, countryId } = useAppSelector(state => state.globalState);
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [accountemployeeid, setAccountemployeeid] = useState<number | null>(null);
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);
    const [countryArray, SetCountryArray] = useState<any | ''>([]);    
    const [selectedOptionCountry, setselectedOptionCountry] = useState<{ [object: string]: any }>();
    const [showErrorSummary, setShowErrorSummary] = useState(false);
    const formikRef = useRef<any>(null);
    useEffect(() => {
        getCountriesAsync();
    }, [])

    useEffect(() => {
        if (countryArray.length > 0 && formikRef.current) {
            const formikValues = formikRef.current.values;
            const country = countryArray.find((c: any) => c.value == formikValues.CountryId);
            setselectedOptionCountry(country || null);
        }
    }, [countryArray, formikRef.current?.values.CountryId]);
    
    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(InvoiceTemplateInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            setAccountInvoiceTemplateId(tempObj.AccountInvoiceTemplateId)
            setCurrentFieldsData(stateItem);
           // setSelectedOptionDropDown(countryArray.find((country: any) => country.value == stateItem.CountryId));
            setIsCanvasLoader(false);
            setselectedOptionCountry(countryArray.find((option: any) => option.value == tempObj.CountryId));
        }
        else {
            setselectedOptionCountry(countryArray.find((option: any) => option.value == countryId));
            setAccountInvoiceTemplateId(0)
            setCurrentFieldsData(InvoiceTemplateInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
    },
     [selectedRecord])
    const getCountriesAsync = async () => {
        const response = await fetchAPI("api/v2/ClientContacts/Countries", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        if (Object.keys(json.Data).length !== 0) {
            json.Data.map((item: any) => {
                item.value = item.CountryId;
                item.label = item.Country;
                delete item.CountryId;
                delete item.Country;
            });
            SetCountryArray(json.Data);
        }
    }

    const handleCloseOnClickEvent = () => {
        /* dispatch(resetSelectedRecordObjectInState()); */
    }


    // const handleChangeCountry = (data: any, Name: string, values: any) => {
    //     const { value, label } = data;
    //     setselectedOptionCountry({ value: value, label: label });
    // }
      const handleChangeCountry = (selectedOption: any, setFieldValue: any) => {
        setselectedOptionCountry(selectedOption);
        setFieldValue('CountryId', selectedOption.value);
    }

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateInvoiceTemplateAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Invoice Template Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    console.log('handleSubmit-updateInvoiceTemplateAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                })
        }
        else {
            dispatch(addInvoiceTemplateAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Invoice Template Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    console.log('handleSubmit-addInvoiceTemplateAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    return (
        <>
            <Formik
             innerRef={formikRef}
                initialValues={{
                    
                    ...currentFieldsData,
                    CountryId: countryId 
                    // CountryId: selectedOptionCountry?.value,
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    // AccountInvoiceTemplateName: yup
                    //     .string()
                    //     .label(t('Template Name'))
                    //     .max(600, 'Template Name must not exceed 600 Characters')
                    //     .required(t('Template Name is required')),
                    // AccountName: yup
                    //     .string()
                    //     .label(t('Account Name'))
                    //     .max(600, 'Account Name must not exceed 600 Characters')
                    //     .required(t('Account Name is required')),
                    // CountryId: yup
                    //     .string()
                    //     .label('Country Name')
                    //     .required(t('Country Name is required'))
                    AccountInvoiceTemplateName: yup
                    .string()
                    .label(getValueFromResource('Template Name', dispatch,t))
                    .required(getValueFromResource('Template Name is required', dispatch,t))
                    .max(600, getValueFromResource('Template Name must not exceed 600 Characters', dispatch,t)),
                    AccountName: yup
                    .string()
                    .label(getValueFromResource('Account Name',dispatch, t))
                    .required(getValueFromResource('Account Name is required', dispatch,t))
                    .max(600, getValueFromResource('Account Name must not exceed 600 Characters', dispatch,t)),
                    CountryId: yup
                    .string()
                    .label(getValueFromResource('Country Name', dispatch,t))
                    .required(getValueFromResource('Country Name is required', dispatch,t))

                })}>

                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, handleBlur,setFieldValue  }) => (
                    <Fragment>

                        <div className='card-body card-pad  '>


                            <div className='row'>

                                <div className="col-md-12 mb-2">
                                    <label className="required form-label fs-7 fw-normal mb-2">
                                        {/* {t('Template Name')} */}
                                          {getValueFromResource('Template Name', dispatch,t)}
                                        </label>
                                    <input
                                        value={values.AccountInvoiceTemplateName}
                                        type="text"
                                        name="AccountInvoiceTemplateName"
                                        className="form-control fs-7 fw-normal"
                                        placeholder=
                                        // {t('Template Name')}
                                        {getValueFromResource('Template Name', dispatch,t)}
                                        autoCapitalize="none"
                                        onChange={handleChange('AccountInvoiceTemplateName')}
                                        ref={defaultFocusRef}
                                        // onBlur={() => setFieldTouched('AccountInvoiceTemplateName')}
                                    />
                                    <div style={{ paddingRight: 20 }}>
                                        {touched.AccountInvoiceTemplateName && errors.AccountInvoiceTemplateName &&
                                            <p className='errorMsg'>{errors.AccountInvoiceTemplateName as string}</p>
                                        }
                                    </div>

                                </div>
                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="required form-label fs-7 fw-normal">
                                        {/* {t('Account Name')} */}
                                          {getValueFromResource('Account Name', dispatch,t)}
                                        </label>
                                    <input
                                        type="text"
                                        name="AccountName"
                                        className="form-control fs-7 fw-normal"
                                        value={values.AccountName}
                                        onChange={handleChange('AccountName')}
                                        onBlur={() => setFieldTouched('AccountName')}
                                    />
                                    <div style={{ paddingRight: 20 }}>
                                        {touched.AccountName && errors.AccountName &&
                                            <p className='errorMsg'>{errors.AccountName as string}</p>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="form-label fs-7 fw-normal">
                                        {/* {t('Address1')} */}
                                          {getValueFromResource('Address1', dispatch,t)}
                                        </label>
                                    <input
                                        type="text"
                                        name="Address1"
                                        className="form-control fs-7 fw-normal"
                                        value={values.Address1}
                                        onChange={handleChange('Address1')}
                                    />
                                </div>
                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="form-label fs-7 fw-normal">
                                        {/* {t('Address2')} */}
                                          {getValueFromResource('Address2', dispatch,t)}
                                        </label>
                                    <input
                                        type="text"
                                        name="Address2"
                                        className="form-control fs-7 fw-normal"
                                        value={values.Address2}
                                        onChange={handleChange('Address2')}
                                    />

                                </div>
                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="form-label fs-7 fw-normal">
                                        {/* {t('Zip Code')} */}
                                          {getValueFromResource('Zip Code', dispatch,t)}
                                        </label>
                                    <input
                                        type="text"
                                        name="ZipCode"
                                        className="form-control fs-7 fw-normal"
                                        value={values.ZipCode}
                                        onChange={handleChange('ZipCode')}
                                    />
                                </div>
                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="form-label fs-7 fw-normal">
                                        {/* {t('State')} */}
                                          {getValueFromResource('State', dispatch,t)}
                                        </label>
                                    <input
                                        type="text"
                                        name="State"
                                        className="form-control fs-7 fw-normal"
                                        value={values.State}
                                        onChange={handleChange('State')}
                                    />

                                </div>
                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="form-label fs-7 fw-normal">
                                        {/* {t('City')} */}
                                          {getValueFromResource('City', dispatch,t)}
                                        </label>
                                    <input
                                        type="text"
                                        name="City"
                                        className="form-control fs-7 fw-normal"
                                        value={values.City}
                                        onChange={handleChange('City')}
                                    />

                                </div>

                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="required form-label fs-7 fw-normal">
                                        {/* {t('Country')} */}
                                          {getValueFromResource('Country', dispatch,t)}
                                        </label>
                                    {/* <Select
                                        value={selectedOptionCountry}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        name="CountryId"

                                        defaultValue={countryArray[0]}
                                        onBlur={() => setFieldTouched('CountryId', true)}
                                        onChange={(selectedOption) => {
                                            handleChange({
                                                target: {
                                                    id: "CountryId",
                                                    value: selectedOption?.value
                                                },
                                            });
                                        }}
                                        options={countryArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    /> */}
                                    <Select
                                                    value={selectedOptionCountry}
                                                    id="CountryId"
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    name="CountryId"
                                                    onBlur={() => setFieldTouched('CountryId', true)}
                                                    // onChange={(e) => handleChangeCountry(e, 'CountryId', values)}
                                                    onChange={(selectedOption) => handleChangeCountry(selectedOption, setFieldValue)}
                                                    options={countryArray}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                    <div style={{ paddingRight: 20 }}>
                                        {touched.CountryId && errors.CountryId &&
                                            <p className='errorMsg'>{errors.CountryId as string}</p>
                                        }
                                    </div>
                                </div>

                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="form-label fs-7 fw-normal">
                                        {/* {t('EMailAddress')} */}
                                          {getValueFromResource('EMailAddress', dispatch,t)}
                                        </label>
                                    <input
                                        type="text"
                                        name="EMailAddress"
                                        className="form-control fs-7 fw-normal"
                                        value={values.EMailAddress}
                                        onChange={handleChange('EMailAddress')}
                                    />
                                </div>
                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="form-label fs-7 fw-normal">
                                        {/* {t('Telephone')} */}
                                          {getValueFromResource('Telephone', dispatch,t)}
                                        </label>
                                    <input
                                        type="text"
                                        name="Telephone"
                                        className="form-control fs-7 fw-normal"
                                        value={values.Telephone}
                                        onChange={handleChange('Telephone')}
                                    />
                                </div>
                                <div className="col-md-6 mb-2 mt-2">
                                    <label className="form-label fs-7 fw-normal">
                                        {/* {t('Fax')} */}
                                          {getValueFromResource('Fax', dispatch,t)}
                                        </label>
                                    <input
                                        type="text"
                                        name="Fax"
                                        className="form-control fs-7 fw-normal"
                                        value={values.Fax}
                                        onChange={handleChange('Fax')}
                                    />
                                </div>

                                <div className="mb-1">
                                    <label className="fs-7 fs-7 fw-normal mb-2">
                                        {/* {t('Invoice Footer')} */}
                                          {getValueFromResource('Invoice Footer', dispatch,t)}
                                        </label>
                                    <div className={"form-group"}>
                                        <textarea id="txtTimesheetDescription" value={values.InvoiceFooter} onChange={handleChange('InvoiceFooter')} className={"form-control fs-7 fs-7 fw-normal"} rows={4} style={{ borderRadius: 0 }}>
                                        </textarea>
                                    </div>
                                </div>

                                {Object.keys(selectedRecord).length > 0 ? (
                                    <div className="mb-0" >
                                        <label className="fs-7 fw-normal mt-2">
                                            {/* {t('Disabled')} */}
                                              {getValueFromResource('Disabled', dispatch,t)}
                                            </label>
                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                onChange={handleChange('IsDisabled')}
                                            />
                                        </div>
                                    </div>
                                ) : null}

                      {showErrorSummary && Object.keys(errors).length > 0 && (
                        <div className="mt-3 alert alert-danger">
                            <strong>
                                {/* {t('Error Summary')}: */}
                                {getValueFromResource('Error Summary', dispatch,t)}: 
                                </strong>
                            <ul>
                                {Object.keys(errors).map((fieldName, index) => (
                                    <li key={index}>{errors[fieldName] as string}</li>
                                ))}
                        </ul>
                    </div>
                )}

                            </div>


                        </div>

                        <div className='card-footer pt-4'>
                            <div className='d-flex flex-stack float-end'>
                                <button
                                    ref={closeButtonRef}
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    id="kt_OffCanvas"
                                    onClick={handleCloseOnClickEvent}
                                >
                                    {/* {t('Cancel')} */}
                                      {getValueFromResource('Cancel', dispatch,t)}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    onClick={() => { setShowErrorSummary(true); 
                                        handleSubmit();
                                    }}
                                   // onClick={() => handleSubmit()}
                                   // disabled={!isValid}
                                    data-kt-element='send'
                                >
                                     {/* {t('Save')}     */}
                                       {getValueFromResource('Save', dispatch,t)}
                                </button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>

    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}